<div class="viewer-container">
  <div [hidden]="!isToolbarOpen" class="map-toolbar left-toolbar-container d-flex flex-column align-items-center">
    @if ((flagService.getFlags$() | async)?.[FeatureFlags.PROPERTIES]) {
      <app-properties-locations-manager
        class="d-flex"
        [disabled]="!(mapService.mapInitialized$ | async)"
        [infoProperties]="viewerService.infoProperties$ | async"
        [enabledProperties]="viewerService.enableProperties$ | async"
        [enabledPropertiesReport]="viewerService.enablePropertiesReport$ | async"
        [enabledTool]="toolbarService.enabledTool$ | async">
      </app-properties-locations-manager>
    }
    <app-developer-tools *ngIf="viewerService.developerTools$ | async"></app-developer-tools>
    <app-collection-manager *ngIf="viewerService.developerTools$ | async"></app-collection-manager>
    <app-user-data #userData [enabledProperties]="viewerService.enableProperties$ | async" [enabledTool]="toolbarService.enabledTool$ | async"></app-user-data>
    <app-search-enhanced-results-toolbar
      [enabledTool]="toolbarService.enabledTool$ | async"
      [is3DMode]="viewerService.is3DMode()">
    </app-search-enhanced-results-toolbar>

      @if ((flagService.getFlags$() | async)?.[FeatureFlags.AI_AGENTS]){
          <app-ai-chat-toolbar
                  [enabledTool]="toolbarService.enabledTool$ | async"
                  [agents]="aiAgents"
                  [toolRenderers]="aiToolRenderers">
          </app-ai-chat-toolbar>
      }

      @if ((flagService.getFlags$() | async)?.[FeatureFlags.CUSTOM_ELEMENTS_DETECTION]){
          <app-custom-elements-toolbar
                  [enabledTool]="toolbarService.enabledTool$ | async"
                  [is3DMode]="viewerService.is3DMode()">
          </app-custom-elements-toolbar>
      }

    <app-search-enhanced-heatmap-toolbar
      *ngIf="viewerService.developerTools$ | async"
      [enabledTool]="toolbarService.enabledTool$ | async"></app-search-enhanced-heatmap-toolbar>
  </div>
  <div #mapContainer class="map-container">

    <lib-style-legend-panel></lib-style-legend-panel>

    <div class="top-toolbar-container" *ngIf="(viewerService.projectStatus$ | async)?.multiLayerEnabled">
      <app-dummy-collections-timeline
        *ngIf="viewerService.showDummyTimeline() && !(viewerService.isActivatedBaseMap$ | async)"
        [enabledFilters]="mapService.mapInitialized$ | async"
        [enabledDebug]="viewerService.developerTools$ | async"
        [timelineBlocked]="viewerService.lockCollection$ | async"
        [swipeStatus]="viewerService.enableSwipe$ | async"
        ></app-dummy-collections-timeline>

      <app-collections-timeline
        [aois]="(viewerService.projectStatus$ | async)?.enabledAOIs"
        [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"
        [enabledFilters]="mapService.mapInitialized$ | async"
        *ngIf="viewerService.show2DTimeline() && !(viewerService.isActivatedBaseMap$ | async)"
        [enabledDebug]="viewerService.developerTools$ | async"
        [timelineBlocked]="viewerService.lockCollection$ | async"
        [enableContrast]="viewerService.enableContrast$ | async"
        [swipeStatus]="viewerService.enableSwipe$ | async"
        ></app-collections-timeline>

      <app-collections-discrete-selector
        [aois]="(viewerService.projectStatus$ | async)?.enabledImageAOIs"
        [selectedImage]="viewerService.image$ | async"
        *ngIf="viewerService.is3DMode() && !(viewerService.isActivatedBaseMap$ | async)"
        [class.d-none]="!(viewerService.projectStatus$ | async)?.enabledImageAOIs?.length"
        ></app-collections-discrete-selector>
    </div>

    <div class="row align-items-start toolbar-toast-container">
      <app-vision-toast
        [notification]="toastService.notifications$ | async"
        [remove]="toastService.removeNotification$ | async"
        [removeAll]="toastService.removeAllNotification$ | async"></app-vision-toast>
    </div>
    <div class="toolbar-viewer d-flex flex-column align-items-end ">
        <div class="m-2 d-flex flex-column align-items-end">
<!--            @if ((flagService.getFlags$() | async)?.[FeatureFlags.AI_AGENTS]) {-->
<!--                <app-compact-map-controller-->
<!--                        [mode]="viewerService.collectionMode"-->
<!--                        [orientation]="viewerService.orientationSelected"-->
<!--                        [imageAOIs]="(viewerService.projectStatus$ | async)?.enabledImageAOIs"-->
<!--                        [aois]="(viewerService.projectStatus$ | async)?.enabledAOIs"-->
<!--                        [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"-->
<!--                        [zoom]="viewerService.zoomEnd$ | async"-->
<!--                        [initialized]="mapService.mapInitialized$ | async"-->
<!--                        [isBaseMapActivated]="viewerService.isActivatedBaseMap$ | async"-->
<!--                        [agents]="aiAgents">-->
<!--                </app-compact-map-controller>-->
<!--            } @else {-->
                <div class="d-flex justify-content-end w-100">
                    <app-loading class="loading-div m-3 w-auto" [loadingId]="'tiles'"></app-loading>
                </div>
                <app-zoom-manager class="m-3 toolbar-item"></app-zoom-manager>
                <app-collection-controller
                        [mode]="viewerService.collectionMode"
                        [orientation]="viewerService.orientationSelected"
                        [imageAOIs]="(viewerService.projectStatus$ | async)?.enabledImageAOIs"
                        [aois]="(viewerService.projectStatus$ | async)?.enabledAOIs"
                        [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"
                        [zoom]="viewerService.zoomEnd$ | async"
                        [initialized]="mapService.mapInitialized$ | async"
                        [controllerBlocked]="viewerService.lockCollection$ | async"
                        [isBaseMapActivated]="viewerService.isActivatedBaseMap$ | async"
                        [agents]="(flagService.getFlags$() | async)?.[FeatureFlags.AI_AGENTS] ? aiAgents : []"
                        class="toolbar-item">
                </app-collection-controller>
<!--            }-->
        </div>
      <div class="d-flex align-items-end">
          <app-scale-bar class="me-1 pe-auto"
                         [discreteEnabled]="mapService.discreteEnabled$ | async"
                         [unitSelected]="'metric'"
                         [viewerConfiguration]="viewerConfigurationService.viewerConfiguration$ | async"></app-scale-bar>
          <app-status-bar
          [target]="'custom-attribution-map' + mapService.getMapIndex()"
          [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"
          [visibleDate]="viewerService.centerImageDate$ | async"
          [mapCenterCoordinates]="viewerService.mapCenterCoordinates$ | async"
          [discreteEnabled]="mapService.discreteEnabled$ | async"
          [dsmStatus]="viewerService.dsmStatus$ | async"
          [zoom]="viewerService.getZoom()"></app-status-bar>
      </div>
    </div>
    <app-compound-viewer></app-compound-viewer>
    <lib-layer-feature-panel></lib-layer-feature-panel>
    <lib-feature-detail-panel></lib-feature-detail-panel>
    <lib-vlm-layer-panel></lib-vlm-layer-panel>
    <lib-pipeline-embeddings-panel></lib-pipeline-embeddings-panel>
    <lib-pipeline-aoi-panel></lib-pipeline-aoi-panel>
  </div>
</div>


